import { DocumentoArrecadacaoRetificacaoBase1TO } from "src/app/pagamento/models/documento-arrecadacao-retificacao-base1-to";

export const DOCUMENTO_ARRECADACAO_CPF_SIMPLIFICADA_MOCK: DocumentoArrecadacaoRetificacaoBase1TO = {
  numeroRegistro: "800342715", 
  numeroDocumento: "10110420709007528", 
  ni: "03672686557", 
  dataArrecadacao: "2023-08-31", 
  dataVencimento: "2023-07-31", 
  periodoApuracao: "2022-12-31", 
  referencia: null, 
  processo: null, 
  idCEF: null, 
  vrba: null, 
  vrbaPercentual: null, 
  codigoBanco: "104", 
  codigoAgencia: "0739", 
  codigoReceita01: "0211", 
  codigoReceita02: "3244", 
  codigoReceita03: "0641", 
  codigoExtensaoReceita01: null, 
  valorReceita01: 544.13, 
  valorReceita02: 55.66, 
  valorReceita03: 17.08, 
  valorTotal: 616.87, 
  tipoDocumento: { 
    codigo: 4, 
    descricao: "DARF" 
  }, 
  situacaoDocumento: { 
    codigo: 1, 
    descricao: "Original" 
  }, 
  tiicCd: null, 
  idVersao: "1693631892000", 
  isDocumentoNumerado: false, 
  isNiInvalido: false, 
  isCancelaDocAlocPaex: false, 
  isAlteraPABase2: null, 
  isAlteradoDocumentoAlocado: null, 
  processoAlteracao: null, 
  origemErro: null, 
  desmembramentos: null 
};
